// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"400":"f64d15a5","579":"bc1258b6","620":"f64d15a5","660":"9d432519","709":"9d432519"}[chunkId] + ".chunk.css";
};